import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import './PasswordInput.css';

/**
 * Password input with a show/hide eye toggle.
 *
 * All extra props (value, onChange, placeholder, required, autoComplete,
 * autoFocus, className, etc.) are forwarded straight to the underlying
 * <input>, so this drops into existing forms without changing their styling.
 * The wrapper keeps the input full-width and the eye button inside its right
 * edge; pass `wrapperClassName` if a parent needs to tweak the wrapper itself.
 */
function PasswordInput({ className, style, wrapperClassName, ...inputProps }) {
    const [visible, setVisible] = useState(false);

    return (
        <div className={`hms-pw-field${wrapperClassName ? ` ${wrapperClassName}` : ''}`}>
            <input
                {...inputProps}
                type={visible ? 'text' : 'password'}
                className={className}
                style={{ ...style, paddingRight: '2.75rem' }}
            />
            <button
                type="button"
                className="hms-pw-toggle"
                onClick={() => setVisible((prev) => !prev)}
                aria-label={visible ? 'Hide password' : 'Show password'}
            >
                <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} className="hms-pw-icon" />
            </button>
        </div>
    );
}

export default PasswordInput;
